import { forwardRef, useImperativeHandle, useRef } from 'react';
import {
  Button,
} from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { useScreenReader } from '../../../../screen-reader/ScreenReaderHooks';
import { useRegisterSwitchAccessScanEvent } from '../../../../switch-access/SwitchAccessHooks';
import './ReplayMatchingActivityAction.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onClick: () => { },
  disabled: false,
};
const ReplayMatchingActivityAction = forwardRef((p, ref) => {
  const {
    onClick,
    disabled,
  } = { ...defaultProps, ...filterUndefined({ ...p }) };
  const replayButtonRef = useRef(null);

  const {
    screenReaderOn,
    readWhenScreenReaderIsOn,
  } = useScreenReader();

  useImperativeHandle(ref, () => ({
    getEnableElements: () => (replayButtonRef.current),
  }));

  useRegisterSwitchAccessScanEvent(replayButtonRef, () => {
    readWhenScreenReaderIsOn(replayButtonRef.current);
  });

  return (
    <Button
      color='primary'
      className='btn-blue-primary replay-button'
      endIcon={<ReplayIcon />}
      onClick={onClick}
      disabled={disabled}
      ref={replayButtonRef}
      alt='Replay Activity Cards'
      data-switch-access-scan={screenReaderOn ? 'true' : 'false'}
      data-test='matching-activity-replay-action'
      tabIndex={-1}
    >
      Replay
    </Button>
  );
});

export default ReplayMatchingActivityAction;
